import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ArrowBackIcon,
  Breadcrumbs,
  ColorBox,
  Grid,
  Link,
  PageHeader,
  Typography
} from '@esgian/esgianui';
import { getCountryDetail, getActivePorts, getCountryTopPorts } from '@api/Countries';
import { DATE_FORMAT, DEFAULT_NUM_PORT_CALLS, GEOGRAPHICAL_TYPES } from '@constants';
import CountryProfileSection from '@components/Sections/ShipAnalytics/CountryProfileSection';
import { CommercialCategoryTypeSelect, OperatorTypeSelect } from '@components/Inputs';
import {
  getLatestPortCalls,
  getPortCallSummary,
  getPortCongestion,
  getPortsDetails,
  getUpcomingPortCalls
} from '@api';
import moment from 'moment/moment';
import { useSelector } from 'react-redux';
import { getCommercialCategoryType, getOperatorType } from '@store/features';
import { useSegment } from '@hooks';
import { useQueries, useQuery } from '@tanstack/react-query';

function CountryProfilePage() {
  const params = useParams();
  const navigate = useNavigate();
  const { isRoRo } = useSegment();

  const routeChange = (path) => {
    navigate(path);
  };
  const detailsQuery = useQuery({
    placeholderData: {},
    queryKey: ['countryDetails', params.countryId],
    queryFn: ({ signal }) => getCountryDetail(signal, Number(params.countryId))
  });

  const { name } = detailsQuery.data;
  return (
    <Grid item container spacing={2}>
      <Grid item>
        <ColorBox onClick={() => routeChange(-1)}>
          <ArrowBackIcon fontSize={'small'} />
        </ColorBox>
      </Grid>
      <Grid item>
        <PageHeader
          loading={detailsQuery.isFetching}
          title={`${name}`}
          breadcrumbs={
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                color="inherit"
                sx={{ cursor: 'pointer' }}
                onClick={() => routeChange('/commercial-analytics')}>
                Home
              </Link>
              <Link
                sx={{ cursor: 'pointer' }}
                underline="hover"
                color="inherit"
                onClick={() => routeChange('/commercial-analytics')}>
                Commercial Analytics
              </Link>
              <Typography color="primary">Country Profile</Typography>
            </Breadcrumbs>
          }
        />
      </Grid>
      <Grid item xs={12}>
        {isRoRo ? <OperatorTypeSelect /> : <CommercialCategoryTypeSelect />}
      </Grid>
      <Grid item xs={12}>
        <CountryProfileSection countryName={name} />
      </Grid>
    </Grid>
  );
}

CountryProfilePage.propTypes = {};

CountryProfilePage.defaultProps = {};

export default CountryProfilePage;
